import { PREVIEW_ACCOUNT_MESSAGE, PREVIEW_ACCOUNT_PLAN_LABEL } from '@shared/preview-account';
import { useSyncExternalStore } from 'react';

export { PREVIEW_ACCOUNT_MESSAGE, PREVIEW_ACCOUNT_PLAN_LABEL };

let previewAccountFlag = false;
const listeners = new Set<() => void>();

export function setPreviewAccountFlag(value: boolean): void {
  if (previewAccountFlag === value) return;
  previewAccountFlag = value;
  listeners.forEach((listener) => listener());
}

export function isPreviewAccountFlagged(): boolean {
  return previewAccountFlag;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useIsPreviewAccount(): boolean {
  return useSyncExternalStore(subscribe, isPreviewAccountFlagged, () => false);
}
